import { render, staticRenderFns } from "./PatientJourneyV2.vue?vue&type=template&id=f25be780&scoped=true"
import script from "./PatientJourneyV2.vue?vue&type=script&lang=js"
export * from "./PatientJourneyV2.vue?vue&type=script&lang=js"
import style0 from "./PatientJourneyV2.vue?vue&type=style&index=0&id=f25be780&prod&lang=css"
import style1 from "./PatientJourneyV2.vue?vue&type=style&index=1&id=f25be780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25be780",
  null
  
)

export default component.exports